import React from 'react';

import Button from '@mui/material/Button';
import Skeleton from '@mui/material/Skeleton';

import {
    useCurrentDebrief,
    useMapSettings,
    useAnalytics,
} from 'ff/debrief/hooks';

interface Props {
    linkToDebrief: React.ElementType;
}

const DebriefButton = (props: React.PropsWithChildren<Props>) => {
    const { debrief, isLoading, isPending, isProcessing, isError, hasDebrief } =
        useCurrentDebrief();
    const { resetMap } = useMapSettings();
    const { logDebriefButtonClick } = useAnalytics();

    const handleClick = () => {
        resetMap();
        logDebriefButtonClick({
            score: debrief.score,
            iapCount: debrief.instrumentProcedureCount,
        });
    };

    if (isLoading || isError) {
        return (
            <Button variant="contained" size="small" disabled>
                <Skeleton variant="rounded" height={10} width={30} />
            </Button>
        );
    } else if (isPending || isProcessing) {
        return (
            <Button variant="contained" size="small" disabled>
                Analyzing...
            </Button>
        );
    } else if (hasDebrief) {
        return (
            <Button
                component={props.linkToDebrief}
                onClick={handleClick}
                variant="contained"
                size="small"
            >
                Debrief
            </Button>
        );
    } else {
        return (
            <Button component={props.linkToDebrief} variant="outlined">
                Details
            </Button>
        );
    }
};

export default DebriefButton;
